import React from 'react';
import { EditorContext as EditorContextType } from '../../../utils/state/types';

export const EditorContext = React.createContext<EditorContextType>({
  isDummy: false,
});
export const EditorContextProvider = EditorContext.Provider;

export const useEditorContext = () => React.useContext(EditorContext);
